import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Always initialise dataLayer before anything pushes to it.
// This ensures analytics.js event calls never throw even when GTM is absent.
window.dataLayer = window.dataLayer || [];

// Inject GTM programmatically so process.env.REACT_APP_GTM_ID is resolved
// correctly at both dev-server time and production build time (CRA substitutes
// process.env.* at compile time, unlike %REACT_APP_*% in index.html which is
// only substituted during `npm run build`).
const gtmId = process.env.REACT_APP_GTM_ID;
if (typeof gtmId === 'string' && gtmId.startsWith('GTM-')) {
  // dataLayer init event required by GTM before the container script loads
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  // <script async src="https://www.googletagmanager.com/gtm.js?id=GTM-XXXXXX">
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  // <noscript><iframe src="…/ns.html?id=GTM-XXXXXX" …></iframe></noscript>
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.cssText = 'display:none;visibility:hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
